// React
import { createContext } from "react"

export const SuccessContext = createContext<() => void>(() => {})